export const ADVERT_CONFIG = {
  BREAKPOINTS: {
    MOBILE: 1162,
    SMALLER_SCREEN: 1370,
  },

  MIN_MODULES_FOR_MOBILE: 2,
  DEFAULT_VALUATION_CTA_POSITION: 6,
} as const
